import { BlankWorkflow, WorkflowType } from "../../shared/types/workflow";
import { DestinationType } from "../../shared/types/destination";

export const EmptyWorkflow: BlankWorkflow = {
  guid: '',
  name: 'EMPTY',
  type: WorkflowType.BLANK,
  sources: [],
  transformations: {},
  destination: {
    type: DestinationType.ENCLAVE,
  },
  isEmpty: true,
}
